/* import __COLOCATED_TEMPLATE__ from './no-trigger-bot-option.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();